import { FC, HTMLAttributes } from "react";
import { clsx } from "clsx";
import { getScoreGrade } from "../../../../common/Grade";
import classes from "./ScoreMarker.module.less";

interface ScoreMarkerProps extends HTMLAttributes<HTMLDivElement> {
    score?: number;
}

export const ScoreMarker: FC<ScoreMarkerProps> = ({ score = 0, className, ...prop }) => {
    const _className = clsx(className, classes.container);
    const _score = `${score}% (${getScoreGrade(score).grade})`;

    return (
        <div className={_className} {...prop}>
            <div className={clsx(classes.score, score >= 99 && classes.scoreHigh)}>{_score}</div>
        </div>
    );
};
